module.exports = __webpack_public_path__ + "assets/img/home-bg.42167a56.png";